export function AuditorService($http, apexApiUrl) {
    'ngInject';
    return {
        retrieveAuditors: retrieveAuditors,
        retrieveAuditor: retrieveAuditor,
        saveAuditor: saveAuditor,
        deleteAuditor: deleteAuditor
    };

    function retrieveAuditors() {
        return $http({
            method: "GET",
            url: apexApiUrl + "auditors"
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveAuditor(auditorID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "auditors/" + auditorID
        })
            .then(function (response) {
                return response.data;
            });
    }

    function saveAuditor(auditor) {
        if (!auditor.IsNew) {
            return $http({
                method: "PUT",
                url: apexApiUrl + "auditors/" + auditor.Id,
                data: JSON.stringify(auditor),
                headers: { "Content-Type": "application/json" }
            })
                .then(function () {
                    return auditor;
                });
        } else {
            return $http({
                method: "POST",
                url: apexApiUrl + "auditors",
                data: JSON.stringify(auditor),
                headers: { "Content-Type": "application/json" }
            })
                .then(function (response) {
                    return response.data;
                });
        }
    }

    function deleteAuditor(auditorID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "auditors/" + auditorID,
            headers: {
                "Content-Type": "application/json"
            },
            data: {}
        });
    }
}
